import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import PersonAddAltRoundedIcon from '@mui/icons-material/PersonAddAltRounded';
import { CS_PRIMARY } from '@/pages/dashboard/components/dashboard-home/dashboardHomeTokens';

const iconStyle = {
  width: 14,
  height: 14,
  fontSize: 14,
} as const;

const actionButtonSx = {
  minHeight: 38,
  px: 2,
  borderRadius: '10px',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  fontSize: 14,
  fontWeight: 600,
  lineHeight: 1.25,
  '& .MuiButton-startIcon > :nth-of-type(1), & .MuiButton-endIcon > :nth-of-type(1)': {
    width: 14,
    height: 14,
    fontSize: '14px !important',
  },
} as const;

export interface ClientsEmptyStateProps {
  onAddClient: () => void;
}

export const ClientsEmptyState: React.FC<ClientsEmptyStateProps> = ({ onAddClient }) => (
  <Paper
    elevation={0}
    sx={{
      border: 'none',
      borderRadius: '14px',
      bgcolor: '#fff',
      px: { xs: 2, sm: 2.5 },
      py: { xs: 3, sm: 3.5 },
    }}
  >
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      alignItems={{ md: 'center' }}
      justifyContent="space-between"
    >
      <Stack spacing={0.5} sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#0f172a', lineHeight: 1.3 }}>
          Getting started
        </Typography>
        <Typography sx={{ fontSize: 13, color: '#4a5565', lineHeight: 1.45 }}>
          Add your first client to start building meal plans, tracking progress, and scheduling appointments.
        </Typography>
      </Stack>

      <Box sx={{ flexShrink: 0 }}>
        <Button
          variant="contained"
          startIcon={<PersonAddAltRoundedIcon style={iconStyle} />}
          endIcon={<ArrowForwardRoundedIcon style={iconStyle} />}
          onClick={onAddClient}
          sx={{
            ...actionButtonSx,
            bgcolor: CS_PRIMARY,
            boxShadow: 'none',
            '&:hover': { bgcolor: CS_PRIMARY, opacity: 0.92, boxShadow: 'none' },
          }}
        >
          Add your first client
        </Button>
      </Box>
    </Stack>
  </Paper>
);
